import { forwardRef, useImperativeHandle, useRef } from "react";
import { Box, Typography } from "@mui/material";
import ModalLayout from "src/components/shared/atoms/modalLayout";

interface ModalRefType {
  handleOpen: () => void;
}

const InstagramIssuesModal = forwardRef<ModalRefType>((props, ref) => {
  const modalRef = useRef<ModalRefType | null>(null);

  // Expose handleOpen to parent
  useImperativeHandle(ref, () => ({
    handleOpen: () => modalRef.current?.handleOpen(),
  }));

  return (
    <ModalLayout
      headerText="Instagram Setup Issues"
      modalName=""
      ref={modalRef}
      modalCustomStyle={{
        maxWidth: "555px",
        minHeight: "300px",
        width: "100%",
      }}
    >
      <Box>
        <Typography variant="body1" gutterBottom sx={{ color: "red" }}>
          We couldn�t find any valid Instagram accounts/pages connected to your
          Facebook. Possible reasons could be:
        </Typography>

        <Typography variant="body2" component="div">
          <ul style={{ paddingLeft: "20px", margin: 0 }}>
            <li>
              User has not selected any page that is connected to an Instagram
              account.
            </li>
            <li>
              The selected Instagram account is not a Business/Professional
              account.
            </li>
            <li>
              The Facebook page may not be connected to an Instagram account.
            </li>
            <li>
              Some required permissions are missing (e.g.,{" "}
              <code>instagram_basic</code>, <code>business_management</code>).
            </li>
          </ul>
        </Typography>
      </Box>
    </ModalLayout>
  );
});

export default InstagramIssuesModal;
